module.exports = "/components/components/editableMoneyValue-db1846.html";